import React, { useState } from 'react';
import type { FC } from 'react';
import { fields, match, variant } from 'variant';
import type { VariantOf } from 'variant';
import { BackendNumericViewer } from './BackendNumericViewer.js';
import { BackendArrowViewer } from './BackendArrowViewer.js';
import type {
  BackendViewerComponent,
  BackendViewerComponentNames,
} from './backend-viewer.js';

export const BackendScreenSelector = variant({
  Arrow: fields<{
    backendComponentName: BackendViewerComponentNames;
  }>(),
  Numeric: {},
});

export type BackendScreenSelector = VariantOf<typeof BackendScreenSelector>;

interface Props {
  onClose: () => void;
  onSelect?: (backendComponent: BackendViewerComponent) => void;
  initialSelectorType?: BackendScreenSelector;
}

export const BackendScreen: FC<Props> = ({
  onClose,
  onSelect,
  initialSelectorType = BackendScreenSelector.Numeric(),
}) => {
  const [selectorType, setSelectorType] =
    useState<BackendScreenSelector>(initialSelectorType);

  return (
    <>
      {match(selectorType, {
        Arrow: ({ backendComponentName }) => (
          <BackendArrowViewer
            backendComponentName={backendComponentName}
            onSelect={onSelect}
            onClose={onClose}
          />
        ),
        Numeric: () => (
          <BackendNumericViewer
            onViewMore={setSelectorType}
            onClose={onClose}
          />
        ),
      })}
    </>
  );
};
